var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("btn " + _vm.btnClass + " text-white btn-icon-only rounded-circle mt-1")},[_c('i',{class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }